module.exports = __webpack_public_path__ + "img/culture_bg_top.766b1a65.png";